import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'

const BenefitsStyled = styled.div`
  width: 100%;
`

const BenefitsListStyled = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -0.625rem;
`

const BenefitsListItemStyled = styled.li`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-basis: 50%;
  max-width: 50%;
  padding: 0 0.625rem 3.5rem;

  > * {
    max-width: 13.25rem;
  }

  @media ${media.phone} {
    flex-basis: 25%;
    max-width: 25%;
    padding: 0 0.625rem 10.625rem;
  }
`

export { BenefitsStyled, BenefitsListStyled, BenefitsListItemStyled }
